import {reformatMenuResponse} from '@/utilities/MenuFunctions'

export const Show = "isShow"
export const MobileShow = "isMobileShow"
export const Items = "items"


const state = {
  [Show]: true,
  [MobileShow]: false,
  [Items]: [],
}

const getters = {
  [Show](state) {
    return state[Show];
  },
  [MobileShow](state) {
    return state[MobileShow];
  },
  [Items](state) {
    return state[Items];
  }
}

const mutations = {
  [Show](state, value) {
    state[Show] = value;
  },
  [MobileShow](state, value) {
    state[MobileShow] = value;
  },
  [Items](state, value) {
    state[Items] = reformatMenuResponse(value);
  }
}

const actions = {
  [Show](context, value) {
    context.commit(Show, !!value)
  },
  toggle(context, value) {
    context.commit(Show, !context.state[Show])
  },
  [Items](context, value) {
    let reformat = [];


    context.commit(Items, value)
  },
  [MobileShow](context, value) {
    context.commit(MobileShow, !!value)
  },
  toggleMobile(context, value) {
    context.commit(MobileShow, !context.state[MobileShow])
  }
}

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations
}